/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Embed_DescInputs */

const en_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed an AD track into MXF, MOV, MP4...`)
};

const fr_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrer une piste publicitaire dans un fichier MXF, MOV, MP4...`)
};

const de_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Werbespur in MXF, MOV, MP4 einbetten...`)
};

const it_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporare una traccia pubblicitaria in file MXF, MOV, MP4...`)
};

const ru_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание рекламного блока в файлы MXF, MOV, MP4...`)
};

const es_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserta una pista de audio en MXF, MOV, MP4...`)
};

const zh_cn2_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 AD 音轨嵌入 MXF、MOV、MP4 等格式文件中……`)
};

const ja_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF、MOV、MP4ファイルに広告音声トラックを埋め込む...`)
};

const hi_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF, MOV, MP4 आदि फ़ाइलों में विज्ञापन ट्रैक एम्बेड करें।`)
};

const pt_pt2_file_export_audio_embed_desc = /** @type {(inputs: File_Export_Audio_Embed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpore uma faixa de anúncio em MXF, MOV, MP4...`)
};

/**
* | output |
* | --- |
* | "Embed an AD track into MXF, MOV, MP4..." |
*
* @param {File_Export_Audio_Embed_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_embed_desc = /** @type {((inputs?: File_Export_Audio_Embed_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Embed_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_audio_embed_desc(inputs)
	if (locale === "de") return de_file_export_audio_embed_desc(inputs)
	if (locale === "it") return it_file_export_audio_embed_desc(inputs)
	if (locale === "ru") return ru_file_export_audio_embed_desc(inputs)
	if (locale === "es") return es_file_export_audio_embed_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_audio_embed_desc(inputs)
	if (locale === "ja") return ja_file_export_audio_embed_desc(inputs)
	if (locale === "hi") return hi_file_export_audio_embed_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_audio_embed_desc(inputs)
	return en_file_export_audio_embed_desc(inputs)
});